import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getSessionTileCount } from '../../redux/features/firestore/tiles/TilesProvider';
import { track } from '../../helpers/analytics';

/**
 * Tracks session_end analytics when the page becomes hidden + app_open on
 * cold start + page_view on each route change. Painting is always on now,
 * so we just track total session time.
 */
const SessionAnalytics = () => {
    const location = useLocation();
    const hasFiredOpenRef = useRef(false);

    useEffect(() => {
        if (hasFiredOpenRef.current) return;
        hasFiredOpenRef.current = true;
        track('app_open', { referrer: document.referrer || 'direct' });
    }, []);

    useEffect(() => {
        track('page_view', { path: location.pathname });
    }, [location.pathname]);

    useEffect(() => {
        const sessionStartedAt = Date.now();

        const handleVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
                const sessionSeconds = Math.round((Date.now() - sessionStartedAt) / 1000);
                track('session_end', {
                    tiles_painted: getSessionTileCount(),
                    painting_enabled_seconds: sessionSeconds,
                });
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
    }, []);

    return null;
};

export default SessionAnalytics;
